export default __webpack_public_path__ + "static/media/MS.1db1eb78.svg";